import { createSelector } from 'reselect';

import { RootState } from '../types';

export default class SelectedAppointmentContactSelectors {
  static selectAppointmentContact = (state: RootState) => state.selectedAppointmentContact;

  static getSelectedAppointmentContactDescription = createSelector(
    [SelectedAppointmentContactSelectors.selectAppointmentContact],
    (state) => state.description,
  );
}
